export default {
	FavouriteAdd: 'Favourite add',
};
